import { Box, Flex, Grid, HStack, Stack, Text } from "@chakra-ui/layout";
import React, { useContext, useState } from "react";
import { Button, ButtonGroup } from "@chakra-ui/button";
import { useSession } from "next-auth/react";
import { useColorModeValue, useColorMode } from "@chakra-ui/color-mode";
import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { Input } from "@chakra-ui/input";
import TimezoneSelect from "react-timezone-select";
import styled from "@emotion/styled";
import {
  Textarea,
  Switch,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useMediaQuery,
  Tooltip,
  InputGroup,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
} from "@chakra-ui/react";
import { firebaseClient, getToken } from "firebaseClient";

import toast from "react-hot-toast";
import SubscriptionManagement from "components/subscriptionManagement";
import { OrgManagement } from "components/subscriptionManagement/orgManagement";
import { updateEmail } from "../controllers/settings";
import * as analytics from "../utils/analytics";
import { useRouter } from "next/dist/client/router";
import ProtectedRoute from "components/protected-route";
import { QuestionIcon } from "@chakra-ui/icons";
import { Page } from "components/page";
import { getAccount, updateUser, getAuthUrl } from "../utils/sessionHelper";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { RiCloseFill } from "react-icons/ri";
import { IoLogoLinkedin } from "react-icons/io";
import { Icon } from "@chakra-ui/icons";
import { ConfirmPopup } from "components/popups/confirmPopup";

import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { DangerZone } from "components/danger-zone";
import { Integrations } from "components/settings/integrations";
import * as EmailValidator from "email-validator";
import { layerStyle, radius, textStyle, variant } from "theme/names";
import { TweetContext } from "context/tweetContext";
import { colors } from "theme/colors/colors";
import { KeywordsMultiselect } from "components/keywords-multiselect";

import { Select } from "chakra-react-select";
import { AILanguageOptions } from "utils/AILanguageOptions";
import { generateDescription } from "utils/staticStringGeneration";
import { CustomSection } from "components/custom-section";

import { connectLinkedin } from "../controllers/linkedinController";

let tabs = ["general", "integrations", "billing", "team"];

const LanguageSelect = ({ data, setData }) => {
  return (
    <Box w={"500px"}>
      <Select
        name={"languagePreferred"}
        onChange={(e) => {
          setData({ ...data, languagePreferred: e?.value });
        }}
        value={
          AILanguageOptions.filter(
            (option) => option.value === data?.languagePreferred
          )[0]
        }
        useBasicStyles
        options={AILanguageOptions}
        placeholder={"🇺🇸 English (US) (by default)"}
      />
    </Box>
  );
};

function LabelWithTooltip({ label, tooltipLabel }) {
  return (
    <FormLabel
      display={"flex"}
      alignItems={"center"}
      textStyle={textStyle["body.medium.standard"]}
      mt={3}
    >
      {label}
      <Tooltip hasArrow label={tooltipLabel}>
        <QuestionIcon color="gray.400" ml={2.5} />
      </Tooltip>
    </FormLabel>
  );
}

const Settings = ({ query }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const router = useRouter();
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";
  const [isTooSmall] = useMediaQuery("(max-width: 600px)");
  const [selectedTimezone, setSelectedTimezone] = React.useState("");

  const [shareAccount, setShareAccount] = React.useState("");
  const modes: Array<string> = ["editor (coming soon)", "full access"];
  const [selectedMode, setSelectedMode] = React.useState<String>(modes[1]);
  const [refresh, refresher] = React.useState({});
  const [tabId, setTabId] = React.useState(0);
  const [isRefreshingLinkedin, setIsRefreshingLinkedin] = React.useState(false);
  const {
    isOpen: isOpenConfirmDelete,
    onOpen: onOpenConfirmDelete,
    onClose: onCloseConfirmDelete,
  } = useDisclosure();

  const [enableDailyEmail, setEnableDailyEmail] = React.useState(true);
  const [enableWeeklyEmail, setEnableWeeklyEmail] = React.useState(true);
  const [isRtl, setIsRtl] = React.useState(false);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [isUpdatingEmail, setIsUpdatingEmail] = React.useState(false);
  const [isUpdatingTimezone, setIsUpdatingTimezone] = React.useState(false);
  const [isUpdatingKeywords, setIsUpdatingKeywords] = React.useState(false);
  const [isUpdatingLanguagePreferred, setIsUpdatingLanguagePreferred] =
    React.useState(false);
  const [isUpdatingBio, setIsUpdatingBio] = React.useState(false);
  const [isUpdatingTopics, setIsUpdatingTopics] = React.useState(false);
  const [isUpdatingShare, setIsUpdatingShare] = React.useState(false);
  const [isUpdatingAI, setIsUpdatingAI] = React.useState(false);
  const [isUpdatingForceUseFastModel, setIsUpdatingForceUseFastModel] =
    React.useState(false);
  const [disableSponsorship, setDisableSponsorship] = React.useState(false);
  const [tempLevel, setTempLevel] = React.useState(3);
  const [data, setData] = React.useState({
    email: "",
    who: "",
    topics: "",
    languagePreferred: undefined,
  });

  const [userKeywords, setUserKeywords] = React.useState<Array<string>>([]);

  const changeTabFromQuery = (query) => {
    if (query.tab) {
      let match = tabs.find((x) => x == query.tab);
      if (match) {
        let index = tabs.indexOf(match);
        setTabId(index);
      }
    }
  };

  React.useEffect(() => {
    changeTabFromQuery(query);
  }, []);

  React.useEffect(() => {
    console.log("change tab to: " + query.tab);
    changeTabFromQuery(query);
  }, [query.tab]);

  React.useEffect(() => {
    if (getAccount(session)?.id) {
      setData({
        email: getAccount(session).email,
        who: getAccount(session).who,
        topics: getAccount(session).topics,
        languagePreferred: getAccount(session)?.languagePreferred,
        // keywords: getAccount(session)?.keywords && getAccount(session)?.keywords?.join ? getAccount(session)?.keywords?.join(",") : "",
      });
      setUserKeywords(getAccount(session)?.keywords ?? []);
      // setSelectedTimezone({ ...swrData?.user.data.timezoneFull });
      setSelectedTimezone(
        getAccount(session)?.timezone ??
          Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      setEnableWeeklyEmail(!getAccount(session)?.disableWeeklyDigest);
      setIsRtl(getAccount(session)?.isRtl);
      setEnableDailyEmail(!getAccount(session)?.disableDailyInspiration);
      setTempLevel(getAccount(session)?.tempLevel);
      setDisableSponsorship(getAccount(session)?.disableSponsorship);
    }
  }, [session]);

  // console.log(getAccount(session));
  // console.log(getAccount(session)?.languagePreferred);
  // console.log(getAccount(session)?.description);

  // const tweetContext: any = useContext(TweetContext);

  if (!loading && !session) {
    return <ProtectedRoute />;
  } else if (!session) {
    return null;
  }

  // todo get initial value
  // const [AImodel, AImodelSet] = useState("GPT-4")

  // console.log(getAccount(session));
  // console.log(getAccount(session).languagePreferred);

  return (
    <Page
      {...{
        title: "Account settings",
      }}
    >
      <Tabs
        mt={10}
        index={tabId}
        onChange={(index) => {
          setTabId(index);
          router.push(
            {
              pathname: "/settings",
              query: { tab: tabs[index] },
            },
            undefined,
            { shallow: false }
          );
        }}
      >
        <TabList
          {...{
            maxW: ["100%", "none"],
            overflow: "scroll",
          }}
        >
          <Tab _focus={{ outline: "none" }}>General</Tab>
          <Tab _focus={{ outline: "none" }}>Integrations</Tab>
          <Tab _focus={{ outline: "none" }}>Billing</Tab>
          <Tab _focus={{ outline: "none" }}>Team & Permissions</Tab>
        </TabList>

        <TabPanels>
          {true && (
            <TabPanel mt={4}>
              <Stack spacing={4}>
                <CustomSection
                  title="Personal information"
                  description="Your main account information"
                >
                  <Stack>
                    <Stack>
                      <FormControl id="email">
                        <FormLabel
                          textStyle={textStyle["body.medium.standard"]}
                          mt={5}
                        >
                          Email address
                        </FormLabel>
                        <HStack>
                          <Input
                            value={data.email}
                            onChange={(e) =>
                              setData({ ...data, email: e.target.value })
                            }
                            maxW={250}
                            type="email"
                            placeholder="john@gmail.com"
                            isDisabled={true}
                          />
                          <Button
                            isDisabled={
                              getAccount(session)?.email === data.email
                            }
                            isLoading={isUpdatingEmail}
                            variant="primary"
                            onClick={async () => {
                              if (
                                !data.email ||
                                !EmailValidator.validate(data.email)
                              ) {
                                toast.error("please enter valid email");
                                return;
                              }

                              setIsUpdatingEmail(true);
                              getAccount(session).email = data.email;
                              await updateEmail(
                                getAccount(session).id,
                                data.email
                              );
                              // await mutate("/api/auth/session");
                              toast.success("Email updated", {
                                style: {
                                  background: "gray.600",
                                  color: "#222",
                                },
                              });
                              setIsUpdatingEmail(false);
                            }}
                          >
                            Save
                          </Button>
                        </HStack>
                      </FormControl>
                      <FormControl display="flex" flexDirection="column" mb={4}>
                        <FormLabel
                          textStyle={textStyle["body.medium.standard"]}
                          mt={3}
                        >
                          Timezone
                        </FormLabel>
                        <HStack zIndex={9}>
                          <StyledTimezone
                            className="blah"
                            colorMode={colorMode}
                            value={selectedTimezone}
                            onChange={(e) => {
                              setSelectedTimezone(e.value);
                            }}
                          />
                          <Button
                            variant="primary"
                            isDisabled={
                              getAccount(session)?.timezone &&
                              getAccount(session)?.timezone === selectedTimezone
                            }
                            isLoading={isUpdatingTimezone}
                            onClick={async () => {
                              setIsUpdatingTimezone(true);
                              await updateUser(
                                session,
                                { timezone: selectedTimezone },
                                true,
                                true,
                                { toastMessage: "Timezone updated" }
                              );
                              setIsUpdatingTimezone(false);
                            }}
                          >
                            Save
                          </Button>
                        </HStack>
                      </FormControl>
                      <FormControl display="flex" alignItems="center">
                        <Flex
                          width="sm"
                          mt={4}
                          py="2"
                          px="4"
                          layerStyle={layerStyle["bg.border.rounded"]}
                          alignItems="center"
                        >
                          <FormLabel
                            textStyle={textStyle["body.medium.standard"]}
                            mt={3}
                            flex={1}
                          >
                            Dark Mode
                          </FormLabel>
                          <Box
                          // pt={2}
                          >
                            <SunIcon />
                            <Switch
                              ml={3}
                              mr={3}
                              isChecked={colorMode === "dark"}
                              onChange={toggleColorMode}
                            />
                            <MoonIcon />
                          </Box>
                        </Flex>
                      </FormControl>
                      <FormControl display="flex" alignItems="center">
                        <Flex
                          width="sm"
                          mt={4}
                          py="2"
                          px="4"
                          layerStyle={layerStyle["bg.border.rounded"]}
                          alignItems="center"
                        >
                          <FormLabel
                            textStyle={textStyle["body.medium.standard"]}
                            mt={3}
                            flex={1}
                          >
                            Right to left text direction
                          </FormLabel>
                          <Switch
                            mr={7}
                            isChecked={isRtl}
                            onChange={async () => {
                              setIsRtl(!isRtl);
                              await updateUser(
                                session,
                                { isRtl: !isRtl },
                                true,
                                true,
                                { toastMessage: "Text direction updated" }
                              );
                            }}
                          />
                        </Flex>
                      </FormControl>
                    </Stack>
                  </Stack>
                </CustomSection>
                {/* <Box
                p={[4, 8]}
                layerStyle={layerStyle["bg.border.rounded"]}
                borderRadius={radius.lg}
              > */}
                <CustomSection title="Account">
                  <Stack id="linkedin-account">
                    {session?.user?.data?.accounts?.filter(
                      (x) => x.provider == "linkedin"
                    )?.length > 0 ? (
                      <Grid mt={4} gap={4}>
                        <Text textStyle={textStyle["body.medium.light"]}>
                          Connected as{" "}
                          <Box
                            as="span"
                            textStyle={textStyle["body.bold.standard"]}
                          >
                            {
                              session?.user?.data?.accounts?.filter(
                                (x) => x.provider == "linkedin"
                              )[0].name
                            }
                          </Box>
                        </Text>
                        <Flex gap={4} flexWrap="wrap">
                          <Button
                            variant="primary"
                            leftIcon={
                              <Icon viewBox="0 0 16 15">
                                <svg
                                  width="16"
                                  height="15"
                                  viewBox="0 0 16 15"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M14.1875 8.53125C13.7812 8.40625 13.375 8.625 13.25 9.03125C12.5938 11.375 10.4062 13 7.96875 13C5.875 13 4 11.8125 3.0625 10H6.21875C6.625 10 6.96875 9.6875 6.96875 9.25C6.96875 8.84375 6.65625 8.5 6.21875 8.5H1.21875C0.8125 8.5 0.46875 8.84375 0.46875 9.25V14.25C0.46875 14.6875 0.8125 15 1.21875 15C1.65625 15 1.96875 14.6875 1.96875 14.25V11.0625C3.21875 13.1562 5.5 14.5 7.96875 14.5C11.0625 14.5 13.8125 12.4375 14.6875 9.46875C14.8125 9.0625 14.5938 8.65625 14.1875 8.53125ZM14.75 0C14.3125 0 14 0.34375 14 0.75V3.96875C12.75 1.875 10.4688 0.5 8 0.5C4.90625 0.5 2.125 2.59375 1.25 5.5625C1.15625 5.9375 1.375 6.375 1.78125 6.46875C2.1875 6.59375 2.59375 6.375 2.6875 5.96875C3.375 3.65625 5.5625 2 8 2C10.0625 2 11.9375 3.21875 12.875 5H9.75C9.3125 5 9 5.34375 9 5.75C9 6.1875 9.3125 6.5 9.75 6.5H14.75C15.1562 6.5 15.5 6.1875 15.5 5.75V0.75C15.5 0.34375 15.1562 0 14.75 0Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </Icon>
                            }
                            isLoading={isUpdatingAI || isRefreshingLinkedin}
                            onClick={async () => {
                              
                              console.log("refresh li connection");

                              const accountSetupResult: any =
                                await connectLinkedin(
                                  session,
                                  setIsRefreshingLinkedin
                                );
                              if (accountSetupResult?.success === 1) {
                                router.reload();
                              }
                            }}
                          >
                            Refresh
                          </Button>

                          {
                            <Button
                              // mt={2}
                              variant={variant.Button.secondaryDestructive}
                              isLoading={isUpdatingAI}
                              // ml={10}
                              onClick={async () => {
                                onOpenConfirmDelete();
                              }}
                            >
                              Disconnect
                            </Button>
                          }
                        </Flex>
                      </Grid>
                    ) : (
                      <Box mt={4} display="flex" alignItems="center">
                        <Text textStyle={textStyle["body.medium.light"]} mr={4}>
                          Add your LinkedIn account
                        </Text>
                        <Button
                          variant="primary"
                          isLoading={isUpdatingAI || isRefreshingLinkedin}
                          leftIcon={<IoLogoLinkedin fontSize="22px" />}
                          onClick={async () => {
                            
                            console.log("refresh li connection");
                            const accountSetupResult: any =
                              await connectLinkedin(
                                session,
                                setIsRefreshingLinkedin
                              );
                            if (accountSetupResult?.success === 1) {
                              router.reload();
                            }
                          }}
                        >
                          Connect
                        </Button>
                      </Box>
                    )}
                  </Stack>
                </CustomSection>

                <CustomSection
                  title="AI Settings"
                  description="Edit your AI settings to help the AI generate the best
                    content for you"
                >
                  <Stack>
                    <Stack pl={[0, 4]}>
                      <FormControl>
                        <LabelWithTooltip
                          {...{
                            label:
                              (getAccount(session)?.twUserName
                                ? "@" + getAccount(session)?.twUserName + "'s "
                                : "") + "preferred language",
                            tooltipLabel:
                              "Define the language you would like the AI to write in.",
                          }}
                        ></LabelWithTooltip>
                        <HStack>
                          <LanguageSelect
                            {...{
                              data,
                              setData,
                            }}
                          />
                          {
                            <Button
                              isDisabled={
                                JSON.stringify(
                                  getAccount(session)?.languagePreferred
                                ) === JSON.stringify(data.languagePreferred)
                              }
                              isLoading={isUpdatingLanguagePreferred}
                              variant="primary"
                              onClick={async () => {
                                setIsUpdatingLanguagePreferred(true);
                                let newLanguagePreferred =
                                  data.languagePreferred;
                                await updateUser(
                                  session,
                                  {
                                    languagePreferred: newLanguagePreferred,
                                    description: generateDescription(
                                      data.who,
                                      data.topics,
                                      data.languagePreferred
                                    ),
                                  },
                                  true,
                                  true,
                                  {
                                    toastMessage: "Language updated",
                                  }
                                );
                                setIsUpdatingLanguagePreferred(false);
                              }}
                            >
                              Save
                            </Button>
                          }
                        </HStack>
                      </FormControl>

                      <FormControl>
                        <LabelWithTooltip
                          {...{
                            label:
                              (getAccount(session)?.twUserName
                                ? "@" + getAccount(session)?.twUserName + "'s "
                                : "") + "search keywords",
                            tooltipLabel:
                              "Define your main keywords to improve the auto search and the relevance of the daily emails",
                          }}
                        ></LabelWithTooltip>
                        <HStack>
                          <KeywordsMultiselect
                            keywords={userKeywords}
                            setKeywords={setUserKeywords}
                          />
                          {
                            <Button
                              isDisabled={
                                JSON.stringify(
                                  getAccount(session)?.keywords
                                ) === JSON.stringify(userKeywords)
                              }
                              isLoading={isUpdatingKeywords}
                              variant="primary"
                              onClick={async () => {
                                setIsUpdatingKeywords(true);
                                const newKeywords = userKeywords;
                                await updateUser(
                                  session,
                                  {
                                    keywords: newKeywords,
                                    description: generateDescription(
                                      data.who,
                                      data.topics,
                                      data.languagePreferred
                                    ),
                                  },
                                  true,
                                  true,
                                  { toastMessage: "Keywords updated" }
                                );
                                setIsUpdatingKeywords(false);
                              }}
                            >
                              Save
                            </Button>
                          }
                        </HStack>
                      </FormControl>

                      <FormControl>
                        <LabelWithTooltip
                          {...{
                            label:
                              (getAccount(session)?.twUserName
                                ? "@" + getAccount(session)?.twUserName + "'s "
                                : "") + "personal description",
                            tooltipLabel:
                              "Tell us who you are to improve the results personalization",
                          }}
                        ></LabelWithTooltip>
                        <HStack>
                          <Textarea
                            value={data.who}
                            onChange={(e) =>
                              setData({ ...data, who: e.target.value })
                            }
                            maxW={500}
                            // type="maker"
                            placeholder="Maker"
                            borderRadius={radius.lg}
                          />
                          {
                            <Button
                              isDisabled={getAccount(session)?.who === data.who}
                              isLoading={isUpdatingBio}
                              variant="primary"
                              onClick={async () => {
                                if (
                                  !data.who ||
                                  data.who?.length < 10 ||
                                  data.who?.length > 300
                                ) {
                                  toast.error(
                                    "please tell us who you are in 10 to 300 characters"
                                  );
                                  return;
                                }

                                setIsUpdatingBio(true);
                                let formatedWho =
                                  data.who.slice(-1) == "."
                                    ? data.who
                                    : data.who + ".";
                                await updateUser(
                                  session,
                                  {
                                    who: data.who,
                                    description: generateDescription(
                                      data.who,
                                      data.topics,
                                      data.languagePreferred
                                    ),
                                  },
                                  true,
                                  true,
                                  { toastMessage: "Description updated" }
                                );
                                setIsUpdatingBio(false);
                              }}
                            >
                              Save
                            </Button>
                          }
                        </HStack>
                      </FormControl>

                      <FormControl>
                        <LabelWithTooltip
                          {...{
                            label:
                              (getAccount(session)?.twUserName
                                ? "@" + getAccount(session)?.twUserName + "'s "
                                : "") + "main topics",
                            tooltipLabel:
                              "Tell us what you usually post about to improve the results personalization",
                          }}
                        ></LabelWithTooltip>
                        <HStack>
                          <Textarea
                            value={data.topics}
                            onChange={(e) =>
                              setData({ ...data, topics: e.target.value })
                            }
                            maxW={500}
                            placeholder="Building in public"
                            borderRadius={radius.lg}
                          />
                          {
                            <Button
                              isDisabled={
                                getAccount(session)?.topics === data.topics
                              }
                              isLoading={isUpdatingTopics}
                              variant="primary"
                              onClick={async () => {
                                if (
                                  !data.topics ||
                                  data.topics?.length < 10 ||
                                  data.topics?.length > 300
                                ) {
                                  toast.error(
                                    "please tell us what you usually talk about in 10 to 300 characters"
                                  );
                                  return;
                                }

                                setIsUpdatingTopics(true);
                                await updateUser(
                                  session,
                                  {
                                    topics: data.topics,
                                    description: generateDescription(
                                      data.who,
                                      data.topics,
                                      data.languagePreferred
                                    ),
                                  },
                                  true,
                                  true,
                                  { toastMessage: "Topics updated" }
                                );
                                setIsUpdatingTopics(false);
                              }}
                            >
                              Save
                            </Button>
                          }
                        </HStack>
                      </FormControl>

                      <FormControl>
                        <Box mt={6} display="flex" alignItems="center">
                          <Text textStyle={textStyle["body.medium.light"]}>
                            <b>Choose the freedom</b> you want to give to the AI
                            to come up with new ideas.
                          </Text>
                          <Tooltip
                            hasArrow
                            label={
                              "Conservative: will attempt to stay as close as possible to the original post with small variations. Standard: will attempt to stay close to the general idea of the post while offering more impactful variations. Wild: let the AI do its own thing, but you might get a few crazy guesses"
                            }
                          >
                            <QuestionIcon color="gray.400" ml={2.5} />
                          </Tooltip>
                        </Box>
                        <Stack pl={4} maxW={500}>
                          <Flex w="100%" alignItems="center">
                            <Box w="300px">
                              <Flex
                                fontWeight="600"
                                justifyContent="space-between"
                              >
                                <Text
                                  textStyle={textStyle["body.medium.light"]}
                                  mt={4}
                                >
                                  Conservative
                                </Text>
                                <Text
                                  textStyle={textStyle["body.medium.light"]}
                                  mt={4}
                                >
                                  Wild
                                </Text>
                              </Flex>
                              <Box pl={6} pr={6}>
                                <Slider
                                  mt={5}
                                  css={{ marginTop: "-10px", zIndex: 0 }}
                                  width="100%"
                                  min={-2}
                                  max={2}
                                  step={1}
                                  // colorScheme="twitter"
                                  aria-label="temp-selector"
                                  value={tempLevel}
                                  onChange={(val) => {
                                    setTempLevel(val);
                                  }}
                                  focusThumbOnChange={false}
                                >
                                  <SliderTrack>
                                    <SliderFilledTrack />
                                  </SliderTrack>
                                  <SliderThumb />
                                </Slider>
                              </Box>
                            </Box>
                            <Button
                              isDisabled={
                                getAccount(session)?.tempLevel === tempLevel
                              }
                              isLoading={isUpdatingAI}
                              ml={10}
                              mt={2}
                              variant="primary"
                              onClick={async () => {
                                setIsUpdatingAI(true);
                                await updateUser(
                                  session,
                                  { tempLevel: tempLevel },
                                  true,
                                  true,
                                  { toastMessage: "AI model updated" }
                                );
                                setIsUpdatingAI(false);
                              }}
                            >
                              Save
                            </Button>
                          </Flex>
                        </Stack>
                      </FormControl>

                      {getAccount(session)?.subscription?.plan && // show if plan
                        getAccount(session)?.subscription?.plan !== "start" && ( // AND plan !== "start"
                          <FormControl>
                            <Box mt={6} display="flex" alignItems="center">
                              <Text textStyle={textStyle["body.medium.light"]}>
                                <b>Choose the AI model</b> you prefer to be used
                                for Taplio’s AI features.
                              </Text>
                              <Tooltip
                                hasArrow
                                label={
                                  "Conservative: will attempt to stay as close as possible to the original post with small variations. Standard: will attempt to stay close to the general idea of the post while offering more impactful variations. Wild: let the AI do its own thing, but you might get a few crazy guesses"
                                }
                              >
                                <QuestionIcon color="gray.400" ml={2.5} />
                              </Tooltip>
                            </Box>

                            <Text
                              {...{
                                mt: 4,
                                textStyle: textStyle["body.medium.primary"],
                                fontStyle: "italic",
                                fontWeight: "700",
                              }}
                            >
                              GPT-4 is a higher-quality model but slower speed.
                              You have a limited number of GPT-4 credits per
                              month.
                            </Text>
                            <Text
                              {...{
                                mt: 1,
                                textStyle: textStyle["body.medium.primary"],
                                fontStyle: "italic",
                                fontWeight: "700",
                              }}
                            >
                              GPT-3.5 is a lower-quality model but with higher
                              speed. You have an unlimited number of GPT-3.5
                              credits per month.
                            </Text>
                            <ButtonGroup mt={4} size="sm" isAttached>
                              <Button
                                {...{
                                  variant: !getAccount(session)
                                    ?.forceUseFastModel
                                    ? variant.Button.lightSelected
                                    : variant.Button.light,
                                  isLoading:
                                    isUpdatingForceUseFastModel &&
                                    !getAccount(session)?.forceUseFastModel,
                                  onClick: async () => {
                                    setIsUpdatingForceUseFastModel(true);
                                    await updateUser(
                                      session,
                                      { forceUseFastModel: false },
                                      true,
                                      true,
                                      {
                                        toastMessage:
                                          "You are now using GPT-4. It is higher quality but slower and uses credits.",
                                      }
                                    );
                                    setIsUpdatingForceUseFastModel(false);
                                  },
                                }}
                              >
                                GPT-4
                              </Button>
                              <Button
                                {...{
                                  ml: "-px",
                                  variant: getAccount(session)
                                    ?.forceUseFastModel
                                    ? variant.Button.lightSelected
                                    : variant.Button.light,
                                  isLoading:
                                    isUpdatingForceUseFastModel &&
                                    getAccount(session)?.forceUseFastModel,
                                  onClick: async () => {
                                    setIsUpdatingForceUseFastModel(true);
                                    await updateUser(
                                      session,
                                      { forceUseFastModel: true },
                                      true,
                                      true,
                                      {
                                        toastMessage:
                                          "You are now using GPT-3.5. It is faster and unlimited but lower quality.",
                                      }
                                    );
                                    setIsUpdatingForceUseFastModel(false);
                                  },
                                }}
                              >
                                GPT-3.5
                              </Button>
                            </ButtonGroup>
                          </FormControl>
                        )}
                    </Stack>
                  </Stack>
                </CustomSection>
                <CustomSection
                  title="Share your account"
                  description="Add people who will be authorized to post for you from
                    Taplio. Note: that person needs to have a Taplio account as
                    well."
                >
                  <Stack>
                    <Stack pl={4}>
                      <FormControl>
                        <Flex
                          gap={2}
                          flexWrap="wrap"
                          mb={5}
                          mt={5}
                          maxW={500}
                          justifyContent="flex-start"
                        >
                          <InputGroup size="md">
                            <Input
                              placeholder="tibo@taplio.com"
                              value={shareAccount}
                              onChange={(e) => {
                                setShareAccount(e.target.value);
                              }}
                            />
                          </InputGroup>
                          <Menu variant={variant.Menu.secondary}>
                            <MenuButton
                              minW={150}
                              size="md"
                              variant="secondary"
                              as={Button}
                              rightIcon={<ChevronDownIcon />}
                            >
                              {selectedMode}
                            </MenuButton>
                            <MenuList>
                              {modes.map((item, index) => (
                                <MenuItem
                                  isDisabled={item == modes[0]}
                                  onClick={() => setSelectedMode(item)}
                                  key={"menuSelectMore-" + index}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </MenuList>
                          </Menu>
                          <Button
                            variant="primary"
                            isDisabled={!(shareAccount?.length > 0)}
                            isLoading={isUpdatingShare}
                            onClick={async () => {
                              setIsUpdatingShare(true);
                              let dataToSend = {
                                type: selectedMode,
                                email: shareAccount,
                                mode: "add",
                                idUser: getAccount(session).id,
                                idAccount: getAccount(session).idAccount,
                                tokenUserId: session.user.uid,
                                token: await getToken(
                                  session,
                                  "settings-share"
                                ),
                              };
                              let response = await fetch("/api/shareAccount", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify(dataToSend),
                              });
                              let data = await response.json();
                              if (data?.success && data.shareAccountsTo) {
                                getAccount(session).shareAccountsTo =
                                  data.shareAccountsTo;
                                setShareAccount("");
                                refresher({});
                                toast.success("Account shared successfully");
                              } else {
                                toast.error("Error: " + data.error);
                              }
                              setIsUpdatingShare(false);
                            }}
                          >
                            Add
                          </Button>
                        </Flex>
                      </FormControl>
                      {getAccount(session)?.shareAccountsTo?.map(
                        (account, index) => (
                          <Flex
                            maxW={500}
                            key={"account-" + index}
                            alignItems="center"
                            justifyContent="space-between"
                            m={2}
                            ml={4}
                            p={2}
                            borderRadius="6px"
                            bg={useColorModeValue("gray.100", "gray.800")}
                          >
                            <Text
                              textStyle={textStyle["body.medium.light"]}
                              ml={"10px"}
                            >
                              {account.email}
                            </Text>
                            <Flex alignItems="center" justifyContent="flex-end">
                              <Text
                                textStyle={textStyle["body.medium.light"]}
                                mr={5}
                              >
                                {account.type}
                              </Text>
                              <IconButton
                                aria-label="delete"
                                color="twitter.600"
                                // variant="outline"
                                size="sm"
                                onClick={async () => {
                                  toast.promise(
                                    new Promise(async (resolve, reject) => {
                                      let dataToSend = {
                                        idUser: getAccount(session).id,
                                        type: account.type,
                                        email: account.email,
                                        mode: "delete",
                                        idGhost: account.id,
                                        tokenUserId: session.user.uid,
                                        token: await getToken(
                                          session,
                                          "settings-share-delete"
                                        ),
                                      };
                                      let response = await fetch(
                                        "/api/shareAccount",
                                        {
                                          method: "POST",
                                          headers: {
                                            "Content-Type": "application/json",
                                          },
                                          body: JSON.stringify(dataToSend),
                                        }
                                      );
                                      let data = await response.json();
                                      if (
                                        data?.success &&
                                        data.shareAccountsTo
                                      ) {
                                        getAccount(session).shareAccountsTo =
                                          data.shareAccountsTo;
                                        refresher({});
                                        resolve(data);
                                      } else {
                                        reject(data.error);
                                      }
                                    }),
                                    {
                                      loading:
                                        "removing access to " + account.email,
                                      success: "Access removed",
                                      error: "An error happened",
                                    }
                                  );
                                }}
                                icon={
                                  <Icon
                                    color={useColorModeValue(
                                      "gray.600",
                                      "gray.100"
                                    )}
                                    as={RiCloseFill}
                                  />
                                }
                              />
                            </Flex>
                          </Flex>
                        )
                      )}
                    </Stack>
                  </Stack>
                </CustomSection>
                {getAccount(session)?.id === session?.user?.uid && (
                  <CustomSection>
                    <DangerZone />
                  </CustomSection>
                )}
              </Stack>
            </TabPanel>
          )}
          <TabPanel mt={4}>
            <Integrations />
          </TabPanel>
          <TabPanel mt={4}>
            <Stack>
              {
                //@ts-ignore
                session?.user?.data?.subscription ? (
                  <Stack pt={10}>
                    {!session?.user?.data?.subscription?.isInOrg ||
                    session?.user?.data?.subscription?.orgRole == "Admin" ? (
                      <SubscriptionManagement session={session} />
                    ) : (
                      <Text textStyle={textStyle["body.medium.standard"]}>
                        You need to be an admin to manage subscriptions
                      </Text>
                    )}
                  </Stack>
                ) : (
                  <Box>
                    <Button
                      maxW="200px"
                      onClick={() => {
                        
                        router.push("/pricing");
                      }}
                      // leftIcon={<FiUnlock />}
                      // bg="blue.100"
                      // _hover={{ bg: "blue.200" }}
                      variant="primary"
                      css={{
                        width: "100%",
                      }}
                    >
                      Start Free Trial
                    </Button>
                  </Box>
                )
              }
            </Stack>
          </TabPanel>
          <TabPanel mt={4}>
            <Stack>
              <OrgManagement />
            </Stack>
          </TabPanel>
        </TabPanels>
      </Tabs>
      <ConfirmPopup
        isOpen={isOpenConfirmDelete}
        onClose={onCloseConfirmDelete}
        title="Disconnect your Linkedin account"
        body={
          "Are you sure you want to disconnect your Linkedin account? You will lose the associated data."
        }
        cta="Disconnect"
        allowClickBackground={true}
        callback={async () => {
          analytics.log("account_disconnected");
          let account = session.user.data.accounts.filter(
            (x) => x.provider == "linkedin"
          )[0];
          session.user.data.accounts.splice(
            session.user.data.accounts.indexOf(account),
            1
          );
          const db = firebaseClient.firestore();
          await db
            .collection("users")
            .doc(session.user.uid)
            .collection("accounts")
            .doc(account.id)
            .delete();
          refresher({});
        }}
      />
    </Page>
  );
};

Settings.getInitialProps = async ({ query }) => {
  return { query };
};

export default Settings;

export const StyledTimezone: any = styled(TimezoneSelect)`
  && {
    width: 250px;
    z-index: 1;

    > div {
      > div {
        > div {
          color: ${({
            // @ts-ignore
            colorMode,
          }) =>
            colorMode === "light"
              ? `${colors.text.lightMode.standard}`
              : `${colors.text.darkMode.standard}`};
        }
      }
      font-size: 14px;
      color: ${({
        // @ts-ignore
        colorMode,
      }) =>
        colorMode === "light"
          ? `${colors.text.lightMode.standard}`
          : `${colors.text.darkMode.standard}`};
      background: ${({
        // @ts-ignore
        colorMode,
      }) => (colorMode === "light" ? "white" : `#1E1E1E`)};
      border: ${({
        // @ts-ignore
        colorMode,
      }) =>
        colorMode === "light"
          ? `1px solid ${colors.border.lightMode.light}`
          : `1px solid ${colors.border.darkMode.light} `};
      border-radius: 10px;
    }
    border: 0;
  }
`;
